import { querySelectorAll } from './querySelectors';

export default function(cnt) {
  if (!/<script/i.test(cnt)) {
    return;
  }

  let element = document.createElement('div');
  element.innerHTML = cnt;

  let scripts = querySelectorAll('script', element);
  let insertScripts = [];

  for (let i = 0; i < scripts.length; i++) {
    let script = scripts[i];
    let scriptElement = document.createElement('script');
    scriptElement.innerHTML = script.innerHTML;

    if (script.hasAttributes()) {
      let attrs = script.attributes;

      for (let j = 0; j < attrs.length; j++) {
        let attrName = attrs[j].name;
        scriptElement[attrName] = attrs[j].value;
      }
    }

    insertScripts.push(scriptElement);

  }

  insertScripts.forEach((script) => {
    window.document.head.appendChild(script);
  });
}
